import axios from 'axios';
import { AutoParFilters, AutoParResponse } from '../types/autopar';

export async function fetchAutoParRecords(filters: AutoParFilters): Promise<AutoParResponse> {
  // Placeholder endpoint. Replace with microservice URL.
  // Example: const url = `/api/autopar/records`; using proxy in package.json.
  try {
    const { data } = await axios.post<AutoParResponse>('/api/autopar/records', filters);
    return data;
  } catch (e) {
    // Fallback stub until backend is ready
    return { records: [], totalCount: 0 };
  }
}

export async function saveParLevel(
  manufacturerId: number,
  catalogNo: string,
  parLevel: number
): Promise<void> {
  await axios.post('/api/autopar/par', { manufacturerId, catalogNo, parLevel });
}

export async function exportAutoPar(filters: AutoParFilters): Promise<Blob> {
  const { data } = await axios.post('/api/autopar/export', filters, { responseType: 'blob' });
  return data;
}
